import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'govuk-react-jsx/govuk/components/button';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const UnableToProceedStaffOrFleetUsage = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcApp.UnableToProceedStaffOrFleetUsage.s4',
    'You cannot apply without staff or fleet parking spaces  - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleButtonClick = () => {
    window.location.assign('/dashboardHub/dashboard-pmc');
  };

  const pageModel = (
    <div>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'pmcApp.UnableToProceedStaffOrFleetUsage.s1',
          'Chargepoints can only be used by staff or fleet'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcApp.UnableToProceedStaffOrFleetUsage.s2',
          'To get this grant, the EV charging infrastructure and chargepoints you plan to install can only be for your staff or fleet vehicles.'
        )}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-7">
        <Button onClick={handleButtonClick}>
          {copyProvider.getCopy(
            'pmcApp.UnableToProceedStaffOrFleetUsage.s3',
            'Manage your applications'
          )}
        </Button>
      </div>
    </div>
  );
  return pageModel;
};
export default UnableToProceedStaffOrFleetUsage;
